function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.75506 0 0 .73578 .96407 17.833)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 3.8637,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "m31.19 1.367c-29.832 0-37.889 35.275-20.469 68.373 16.114 30.617 45.728 43.551 45.728 43.551s29.612-12.934 45.728-43.551c17.42-33.098 9.361-68.373-20.469-68.373-15.896 0-25.259 14.371-25.259 14.371s-9.363-14.371-25.259-14.371z"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "56.449 21.4 38.376 2.455 22.479 18.787 3.754 21.836 14.859 39.69 6.148 59.289 25.746 66.473 23.569 87.813 45.562 90.425 56.667 113.07"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "56.449 21.182 39.029 24.883 22.479 18.787 21.609 30.545 27.488 46.875 42.513 72.134 56.449 84.546"
}), /*#__PURE__*/React.createElement("line", {
  x1: 17.254,
  x2: 22.263,
  y1: 4.416,
  y2: 18.787
}), /*#__PURE__*/React.createElement("polyline", {
  points: "56.449 28.586 39.247 24.883 21.609 30.545 14.859 39.69 2.229 43.828"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "15.077 39.474 27.706 47.094 25.964 66.473 13.335 73.66"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "25.964 66.473 42.513 72.134 45.997 90.644 36.634 100.22"
}), /*#__PURE__*/React.createElement("line", {
  x1: 45.997,
  x2: 56.449,
  y1: 90.425,
  y2: 84.982
}), /*#__PURE__*/React.createElement("polyline", {
  points: "56.449 21.4 74.522 2.455 90.417 18.787 109.14 21.836 98.039 39.69 106.75 59.289 87.151 66.473 89.33 87.813 67.335 90.425 56.231 113.07"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "56.449 21.182 73.869 24.883 90.417 18.787 91.289 30.545 85.41 46.875 70.384 72.134 56.449 84.546"
}), /*#__PURE__*/React.createElement("line", {
  x1: 95.644,
  x2: 90.636,
  y1: 4.416,
  y2: 18.787
}), /*#__PURE__*/React.createElement("polyline", {
  points: "56.449 28.586 73.651 24.883 91.289 30.545 98.039 39.69 110.67 43.828"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "97.821 39.474 85.192 47.094 86.934 66.473 99.563 73.66"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "86.934 66.473 70.384 72.134 66.9 90.644 76.265 100.22"
}), /*#__PURE__*/React.createElement("line", {
  x1: 66.9,
  x2: 56.449,
  y1: 90.425,
  y2: 84.982
}), /*#__PURE__*/React.createElement("line", {
  x1: 56.449,
  x2: 56.449,
  y1: 15.628,
  y2: 28.586
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.75506 0 0 .73578 93.665 17.445)",
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 3.8637,
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "m31.19 1.367c-29.832 0-37.889 35.275-20.469 68.373 16.114 30.617 45.728 43.551 45.728 43.551s29.612-12.934 45.728-43.551c17.42-33.098 9.361-68.373-20.469-68.373-15.896 0-25.259 14.371-25.259 14.371s-9.363-14.371-25.259-14.371z"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "56.449 21.4 38.376 2.455 22.479 18.787 3.754 21.836 14.859 39.69 6.148 59.289 25.746 66.473 23.569 87.813 45.562 90.425 56.667 113.07"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "56.449 21.182 39.029 24.883 22.479 18.787 21.609 30.545 27.488 46.875 42.513 72.134 56.449 84.546"
}), /*#__PURE__*/React.createElement("line", {
  x1: 17.254,
  x2: 22.263,
  y1: 4.416,
  y2: 18.787
}), /*#__PURE__*/React.createElement("polyline", {
  points: "56.449 28.586 39.247 24.883 21.609 30.545 14.859 39.69 2.229 43.828"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "15.077 39.474 27.706 47.094 25.964 66.473 13.335 73.66"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "25.964 66.473 42.513 72.134 45.997 90.644 36.634 100.22"
}), /*#__PURE__*/React.createElement("line", {
  x1: 45.997,
  x2: 56.449,
  y1: 90.425,
  y2: 84.982
}), /*#__PURE__*/React.createElement("polyline", {
  points: "56.449 21.4 74.522 2.455 90.417 18.787 109.14 21.836 98.039 39.69 106.75 59.289 87.151 66.473 89.33 87.813 67.335 90.425 56.231 113.07"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "56.449 21.182 73.869 24.883 90.417 18.787 91.289 30.545 85.41 46.875 70.384 72.134 56.449 84.546"
}), /*#__PURE__*/React.createElement("line", {
  x1: 95.644,
  x2: 90.636,
  y1: 4.416,
  y2: 18.787
}), /*#__PURE__*/React.createElement("polyline", {
  points: "56.449 28.586 73.651 24.883 91.289 30.545 98.039 39.69 110.67 43.828"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "97.821 39.474 85.192 47.094 86.934 66.473 99.563 73.66"
}), /*#__PURE__*/React.createElement("polyline", {
  points: "86.934 66.473 70.384 72.134 66.9 90.644 76.265 100.22"
}), /*#__PURE__*/React.createElement("line", {
  x1: 66.9,
  x2: 56.449,
  y1: 90.425,
  y2: 84.982
}), /*#__PURE__*/React.createElement("line", {
  x1: 56.449,
  x2: 56.449,
  y1: 15.628,
  y2: 28.586
}));

const SvgHeartPair = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Foreground",
  width: 180,
  height: 114.67,
  enableBackground: "new 0 0 112.667 114.667",
  viewBox: "0 0 180 114.67",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeartPair, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/heart-pair.7933eaa4.svg";
export { ForwardRef as ReactComponent };